export type ValType = { key1: string; key2: string }

const buryPointPayloadMap = new Map<string, ValType>([
  // 开料对接
  ['雕刻机-开料对接-刀库-新增', { key1: 'engraving', key2: 'add_knife' }],
  ['雕刻机-开料对接-刀库-编辑', { key1: 'engraving', key2: 'edit_knife' }],
  ['雕刻机-开料对接-刀库-删除', { key1: 'engraving', key2: 'del_knife' }],
  ['雕刻机-开料对接-其他-暂停代码', { key1: 'engraving', key2: 'pauseCode' }],
  [
    '雕刻机-开料对接-工位开始-工位1开始代码',
    { key1: 'engraving', key2: 'oddBeginCode' },
  ],
  [
    '雕刻机-开料对接-工位开始-工位2开始代码',
    { key1: 'engraving', key2: 'evenBeginCode' },
  ],
  [
    '雕刻机-开料对接-正反面开始-正面开始代码',
    { key1: 'engraving', key2: 'beginCodeF' },
  ],
  [
    '雕刻机-开料对接-正反面开始-反面开始代码',
    { key1: 'engraving', key2: 'endCodeF' },
  ],
  [
    '雕刻机-开料对接-正反面结束-正面结束代码',
    { key1: 'engraving', key2: 'beginCodeB' },
  ],
  [
    '雕刻机-开料对接-正反面结束-反面结束代码',
    { key1: 'engraving', key2: 'endCodeB' },
  ],
  [
    '雕刻机-开料对接-板件翻面-工位1翻面代码',
    { key1: 'engraving', key2: 'rollCode' },
  ],
  [
    '雕刻机-开料对接-板件翻面-工位2翻面代码',
    { key1: 'engraving', key2: 'evenRollCode' },
  ],
  [
    '雕刻机-开料对接-自动下料代码-工位1下料代码',
    { key1: 'engraving', key2: 'oddAutoBaitingCode' },
  ],
  [
    '雕刻机-开料对接-自动下料代码-工位2下料代码',
    { key1: 'engraving', key2: 'evenAutoBaitingCode' },
  ],
  [
    '雕刻机-开料对接-工位结束-工位1结束代码',
    { key1: 'engraving', key2: 'oddEndCode' },
  ],
  [
    '雕刻机-开料对接-工位结束-工位2结束代码',
    { key1: 'engraving', key2: 'evenEndCode' },
  ],
  [
    '雕刻机-开料对接-预启动设备-首刀提前',
    { key1: 'engraving', key2: 'firstKnifPreStartCodeInsert' },
  ],
  [
    '雕刻机-开料对接-预启动设备-第二把提前',
    { key1: 'engraving', key2: 'firstKnifPreStartCodeInsert' },
  ],
  [
    '雕刻机-开料对接-真空泵暂停-真空泵1暂停代码',
    { key1: 'engraving', key2: 'oddVacuumPumpPauseCode' },
  ],
  [
    '雕刻机-开料对接-真空泵暂停-真空泵2暂停代码',
    { key1: 'engraving', key2: 'evenVacuumPumpPauseCode' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-孔集中面-正面',
    { key1: 'engraving', key2: 'holeConcentrated_front' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-孔集中面-反面',
    { key1: 'engraving', key2: 'holeConcentrated_back' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-槽集中面-正面',
    { key1: 'engraving', key2: 'apertureSlotConcentrated_front' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-槽集中面-反面',
    { key1: 'engraving', key2: 'apertureSlotConcentrated_back' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-孔槽分流中设置的特殊孔槽优先排在大板正面功能',
    { key1: 'engraving', key2: 'hs_on_front_aft_shunt' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-打穿孔槽所在面跟随该小板上未穿孔槽',
    { key1: 'engraving', key2: 'throughHoleSlotSameSide' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-按比例分配正反面孔槽',
    { key1: 'engraving', key2: 'prorate_holes_slots_of_both_side' },
  ],
  [
    '雕刻机-切割参数-孔槽集中面-启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻版次数',
    { key1: 'engraving', key2: 'cal_turn_num_aft_shunt' },
  ],
  [
    '雕刻机-切割参数-靠边板槽放置-靠边板槽放置-系统默认',
    { key1: 'engraving', key2: 'sideBoardPlacing_default' },
  ],
  [
    '雕刻机-切割参数-靠边板槽放置-靠边板槽放置-大板内侧',
    { key1: 'engraving', key2: 'sideBoardPlacing_inside' },
  ],
  [
    '雕刻机-切割参数-靠边板槽放置-靠边板槽放置-大板外侧',
    { key1: 'engraving', key2: 'sideBoardPlacing_outside' },
  ],
  [
    '雕刻机-切割参数-台面设置-XY轴互换',
    { key1: 'engraving', key2: 'xyReverse' },
  ],
  [
    '雕刻机-切割参数-台面设置-孔槽加工设备自动适配互换',
    { key1: 'engraving', key2: 'auto_adaptation_xy_reverse' },
  ],
  [
    '雕刻机-切割参数-台面设置-工位起始点-左上角',
    { key1: 'engraving', key2: 'startPosition_topLeft' },
  ],
  [
    '雕刻机-切割参数-台面设置-工位起始点-左下角',
    { key1: 'engraving', key2: 'startPosition_bottomRight' },
  ],
  [
    '雕刻机-切割参数-台面设置-工位起始点-右上角',
    { key1: 'engraving', key2: 'startPosition_topRight' },
  ],
  [
    '雕刻机-切割参数-台面设置-工位起始点-右下角',
    { key1: 'engraving', key2: 'startPosition_bottomRight' },
  ],
  [
    '雕刻机-切割参数-台面设置-双工位起始点切换',
    { key1: 'engraving', key2: 'doubleStationReverse' },
  ],
  [
    '雕刻机-切割参数-台面设置-机台平面偏移',
    { key1: 'engraving', key2: 'planeOffset' },
  ],
  [
    '雕刻机-切割参数-台面设置-机台平面偏移-X',
    { key1: 'engraving', key2: 'planeOffset_x' },
  ],
  [
    '雕刻机-切割参数-台面设置-机台平面偏移-Y',
    { key1: 'engraving', key2: 'planeOffset_y' },
  ],
  [
    '雕刻机-切割参数-台面设置-机台平面偏移-Z',
    { key1: 'engraving', key2: 'planeOffset_z' },
  ],
  [
    '雕刻机-切割参数-台面设置-X轴坐标基准对调',
    { key1: 'engraving', key2: 'X_reference_swap' },
  ],
  [
    '雕刻机-切割参数-台面设置-大板反面X坐标基准对调',
    { key1: 'engraving', key2: 'x_reverse_reference_swap' },
  ],
  [
    '雕刻机-切割参数-台面设置-大板反面Y坐标基准对调',
    { key1: 'engraving', key2: 'y_reverse_reference_swap' },
  ],
  [
    '雕刻机-切割参数-台面设置-双工位台面不同尺寸',
    { key1: 'engraving', key2: 'doubleDifferentSize' },
  ],
  [
    '雕刻机-切割参数-台面设置-台面宽度',
    { key1: 'engraving', key2: 'stationWidth' },
  ],
  [
    '雕刻机-切割参数-台面设置-台面宽度限制开关-开启',
    { key1: 'engraving', key2: 'stationWidthLimit' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边方向-左边、上边',
    { key1: 'engraving', key2: 'trimSide_topLeft' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边方向-左边、下边',
    { key1: 'engraving', key2: 'trimSide_bottomLeft' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边方向-右边、上边',
    { key1: 'engraving', key2: 'trimSide_topRight' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边方向-右边、下边',
    { key1: 'engraving', key2: 'trimSide_bottomRight' },
  ],
  [
    '雕刻机-切割参数-修边设置-反面修边顺序-反面最开始修边',
    { key1: 'engraving', key2: 'trimLMoment_1' },
  ],
  [
    '雕刻机-切割参数-修边设置-反面修边顺序-反面孔槽加工后修边',
    { key1: 'engraving', key2: 'trimLMoment_2' },
  ],
  [
    '雕刻机-切割参数-修边设置-正面再修边',
    { key1: 'engraving', key2: 'secondTrimValue' },
  ],
  [
    '雕刻机-切割参数-修边设置-启用新版修边规则',
    { key1: 'engraving', key2: 'new_trim' },
  ],
  [
    '雕刻机-切割参数-余料设置-余料摆放位置-左上角',
    { key1: 'engraving', key2: 'surplusPosition_topLeft' },
  ],
  [
    '雕刻机-切割参数-余料设置-余料摆放位置-左下角',
    { key1: 'engraving', key2: 'surplusPosition_bottomLeft' },
  ],
  [
    '雕刻机-切割参数-余料设置-余料摆放位置-右上角',
    { key1: 'engraving', key2: 'surplusPosition_topRight' },
  ],
  [
    '雕刻机-切割参数-余料设置-余料摆放位置-右下角',
    { key1: 'engraving', key2: 'surplusPosition_bottomRight' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-对刀基准面-台面',
    { key1: 'engraving', key2: 'zReference_counter_top' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-对刀基准面-大板表面',
    { key1: 'engraving', key2: 'zReference_plank_surface' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-空闲时Z高度(H)',
    { key1: 'engraving', key2: 'idleZ' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-相对大板上表面高度',
    { key1: 'engraving', key2: 'knifeBasedOnPlank' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-切透量Z深度(D)',
    { key1: 'engraving', key2: 'cutZ' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-通孔打孔方式-一次打穿',
    { key1: 'engraving', key2: 'throughTowSideToCut_false' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-通孔打孔方式-翻面两次打穿',
    { key1: 'engraving', key2: 'throughTowSideToCut_true' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-通槽打穿方式-一次打穿',
    { key1: 'engraving', key2: 'through_slot_two_side_cut_false' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-通槽打穿方式-翻面两次打穿',
    { key1: 'engraving', key2: 'through_slot_two_side_cut_true' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-小板切割方向-顺时针',
    { key1: 'engraving', key2: 'cutDirection_s' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-小板切割方向-逆时针',
    { key1: 'engraving', key2: 'cutDirection_n' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-自定义铣孔铣槽/内部异形切割方向',
    { key1: 'engraving', key2: 'clock_dir_switch' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-铣孔铣槽方向-顺时针',
    { key1: 'engraving', key2: 'mill_hole_slot_dir_s' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-铣孔铣槽方向-逆时针',
    { key1: 'engraving', key2: 'mill_hole_slot_dir_n' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-内部异形切割方向-顺时针',
    { key1: 'engraving', key2: 'cut_internal_curve_dir_s' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-内部异形切割方向-逆时针',
    { key1: 'engraving', key2: 'cut_internal_curve_dir_n' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-圆弧插补指令切割弧形板',
    { key1: 'engraving', key2: 'cuttingCurvedInterpolationCommand' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-不生成G17/G18/G19面指令',
    { key1: 'engraving', key2: 'noG17G18G19' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-圆弧切割用I、J表示',
    { key1: 'engraving', key2: 'arcCuttingCode' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-边缘槽隔条防断-开启',
    { key1: 'engraving', key2: 'prevent_breakage' },
  ],
  [
    '雕刻机-切割参数-分层切割-铣槽重叠率',
    { key1: 'engraving', key2: 'millingSlotOverlapRate' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-斜下刀速度',
    { key1: 'engraving', key2: 'obliqueSpeed' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-曲线加工速度',
    { key1: 'engraving', key2: 'arcSpeed' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-下刀提前距离',
    { key1: 'engraving', key2: 'cuttingPreDistance' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-斜下刀距离',
    { key1: 'engraving', key2: 'oblique_distance' },
  ],
  [
    '雕刻机-切割参数-分层切割-槽切割两次',
    { key1: 'engraving', key2: 'repeatedSlot' },
  ],
  [
    '雕刻机-切割参数-分层切割-刀径小于等于',
    { key1: 'engraving', key2: 'layered_slot_lt_knife_diameter' },
  ],
  [
    '雕刻机-切割参数-分层切割-槽深度大于等于',
    { key1: 'engraving', key2: 'layered_slot_gt_slot_deep' },
  ],
  [
    '雕刻机-切割参数-分层切割-第二层切割深度',
    { key1: 'engraving', key2: 'layered_slot_second_slot_deep' },
  ],
  [
    '雕刻机-切割参数-开料分层切割设置-不同板厚分层切割',
    { key1: 'engraving', key2: 'isLayeredCut' },
  ],
  [
    '雕刻机-切割参数-开料分层切割设置-新增',
    { key1: 'engraving', key2: 'addPlank' },
  ],
  [
    '雕刻机-切割参数-开料分层切割设置-删除',
    { key1: 'engraving', key2: 'delPlank' },
  ],
  [
    '雕刻机-切割参数-开料分层切割设置-修边也跟随分层切割',
    { key1: 'engraving', key2: 'trimmingFollowsLayeredCutting' },
  ],
  [
    '雕刻机-切割参数-防跑板设置-新版切割算法',
    { key1: 'engraving', key2: 'new_cut_sequence' },
  ],
  [
    '雕刻机-切割参数-防跑板设置-真空强吸力位置',
    { key1: 'engraving', key2: 'strong_suction_zones' },
  ],
  [
    '雕刻机-切割参数-防跑板设置-最小可吸住板件',
    { key1: 'engraving', key2: 'safe_length' },
  ],
  [
    '雕刻机-切割参数-分层切割-小板切割两次',
    { key1: 'engraving', key2: 'repeatedCut' },
  ],
  [
    '雕刻机-切割参数-分层切割-长或宽小于',
    { key1: 'engraving', key2: 'minSafeLength' },
  ],
  [
    '雕刻机-切割参数-分层切割-面积小于',
    { key1: 'engraving', key2: 'minSafeArea' },
  ],
  [
    '雕刻机-切割参数-分层切割-厚度大于',
    { key1: 'engraving', key2: 'minSafeThick' },
  ],
  [
    '雕刻机-切割参数-分层切割-第二次切割深度',
    { key1: 'engraving', key2: 'secondCuttingDepth' },
  ],
  [
    '雕刻机-切割参数-防跑板设置-搭桥留点法',
    { key1: 'engraving', key2: 'bridgeRetentionEnable' },
  ],
  [
    '雕刻机-切割参数-长板加工-启用',
    { key1: 'engraving', key2: 'longPlankCuttingEnable' },
  ],
  [
    '雕刻机-切割参数-长板加工-门板',
    { key1: 'engraving', key2: 'secondaryCuttingList_cutSingleDoor' },
  ],
  [
    '雕刻机-切割参数-长板加工-厚度大于等于选中',
    { key1: 'engraving', key2: 'secondaryCuttingList_cutGeneralPlank' },
  ],
  [
    '雕刻机-切割参数-长板加工-指定板名切割-true',
    {
      key1: 'engraving',
      key2: 'specified_board_secondary_cutting',
    },
  ],
  [
    '雕刻机-切割参数-长板加工-指定板名强制启用-true',
    {
      key1: 'engraving',
      key2: 'force_board_name',
    },
  ],
  [
    '雕刻机-切割参数-长板加工-长边超过',
    { key1: 'engraving', key2: 'longPlankMinLength' },
  ],
  [
    '雕刻机-切割参数-长板加工-短边',
    { key1: 'engraving', key2: 'longPlankShortMinLength' },
  ],
  [
    '雕刻机-切割参数-长板加工-长边放量',
    { key1: 'engraving', key2: 'longPlankExpandedSize' },
  ],
  [
    '雕刻机-切割参数-长板加工-短边放量',
    { key1: 'engraving', key2: 'longPlankShortExpandedSize' },
  ],
  [
    '雕刻机-切割参数-小数保留位数-小数保留位数',
    { key1: 'engraving', key2: 'decimal' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-下料板件表面缓冲',
    { key1: 'engraving', key2: 'plankSurfaceBufferCommand' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-打孔板件表面缓冲',
    { key1: 'engraving', key2: 'hole_surface_buffer' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-拉槽/铣孔/铣槽板件表面缓冲',
    { key1: 'engraving', key2: 'hole_slot_surface_buffer' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-缓冲指令使用-G00',
    { key1: 'engraving', key2: 'buffer_way_G00' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-缓冲指令使用-G01',
    { key1: 'engraving', key2: 'buffer_way_G01' },
  ],
  [
    '雕刻机-切割参数-下刀缓冲指令设置-板件表面缓冲高度偏移',
    { key1: 'engraving', key2: 'buffer_offset' },
  ],
  [
    '雕刻机-切割参数-排版间隙设置-排版间隙设置',
    { key1: 'engraving', key2: 'boardGap' },
  ],
  [
    '雕刻机-切割参数-废料自动截断-切割顺序-先切小板',
    { key1: 'engraving', key2: 'waste_order_plank_first' },
  ],
  [
    '雕刻机-切割参数-废料自动截断-切割顺序-先切废料',
    { key1: 'engraving', key2: 'waste_order_waste_first' },
  ],
  [
    '雕刻机-切割参数-废料自动截断-截断尺寸大于',
    { key1: 'engraving', key2: 'waste_size' },
  ],
  [
    '雕刻机-切割参数-Z扣斜孔加工旋转基准点自定义-Z扣斜孔加工旋转基准点开关',
    { key1: 'engraving', key2: 'ZK_datum_point_customize' },
  ],
  [
    '雕刻机-切割参数-Z扣斜孔加工旋转基准点自定义-旋转基准点(A0)',
    { key1: 'engraving', key2: 'rotate_base_point' },
  ],
  [
    '雕刻机-切割参数-Z扣斜孔加工旋转基准点自定义-旋转角度递增方向',
    { key1: 'engraving', key2: 'rotate_angle_direction' },
  ],
  [
    '雕刻机-切割参数-高光设置-排版时小板高光面排在大板-front',
    { key1: 'engraving', key2: 'high_gloss_front' },
  ],
  [
    '雕刻机-切割参数-高光设置-排版时小板高光面排在大板-back',
    { key1: 'engraving', key2: 'high_gloss_back' },
  ],
  [
    '雕刻机-切割参数-共边切割-共边切割',
    { key1: 'engraving', key2: 'coedge_cutting' },
  ],
  [
    '雕刻机-切割参数-共边加速-共边加速',
    { key1: 'engraving', key2: 'coedge_accelerate' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-圆弧插补指令前缀',
    { key1: 'engraving', key2: 'arcInstruction' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-铣槽时未拉穿的槽自动清理圆角-true',
    { key1: 'engraving', key2: 'auto_clear_fillet_slot' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-铣槽走刀方式-out_to_inner',
    { key1: 'engraving', key2: 'mill_slots_out_to_inner' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-铣槽走刀方式-inner_to_out',
    { key1: 'engraving', key2: 'mill_slots_inner_to_out' },
  ],
  [
    '雕刻机-切割参数-切割打孔方式-加工减少换刀',
    { key1: 'engraving', key2: 'min_knife_change' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-切割转角减速-true',
    { key1: 'engraving', key2: 'angle_deceleration_enabled' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-单独设置小板尺寸范围加工速度-true',
    {
      key1: 'engraving',
      key2: 'small_plank_cut_switch',
    },
  ],
  [
    '雕刻机-切割参数-加工速度优化-单独设置小板尺寸范围加工速度-false',
    {
      key1: 'engraving',
      key2: 'small_plank_cut_switch',
    },
  ],
  [
    '雕刻机-切割参数-加工速度优化-切割转角减速-转角前后距离',
    { key1: 'engraving', key2: 'angle_deceleration_list' },
  ],
  // TODO
  [
    '雕刻机-切割参数-加工速度优化-切割时斜下刀-false',
    { key1: 'engraving', key2: 'oblique' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-反面修边斜下刀-true',
    { key1: 'engraving', key2: 'trim_oblique' },
  ],
  [
    '雕刻机-切割参数-加工速度优化-切割收刀距离补偿',
    { key1: 'engraving', key2: 'retraction_compensation' },
  ],
  [
    '雕刻机-切割参数-长板加工-启用',
    { key1: 'engraving', key2: 'long_plank_cutting_enable' },
  ],
  [
    '雕刻机-切割参数-长板加工-真空关闭方式-单块长板切割后',
    { key1: 'engraving', key2: 'after_one_plank' },
  ],
  [
    '雕刻机-切割参数-长板加工-真空关闭方式-整张大板切割后',
    { key1: 'engraving', key2: 'after_all_plank' },
  ],
  [
    '雕刻机-切割参数-废料自动截断-废料自动截断-true',
    { key1: 'engraving', key2: 'waste_cutting' },
  ],
  [
    '雕刻机-切割参数-废料自动截断-截断尺寸大于',
    { key1: 'engraving', key2: 'waste_size' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面加工板正面生成修边路径且先修边-true',
    { key1: 'engraving', key2: 'is_first_trim_single_panel' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面加工板正面生成修边路径且先修边方向-左边、上边',
    { key1: 'engraving', key2: 'topLeft' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面加工板正面生成修边路径且先修边方向-左边、下边',
    { key1: 'engraving', key2: 'bottomLeft' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面加工板正面生成修边路径且先修边方向-右边、上边',
    { key1: 'engraving', key2: 'topRight' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面加工板正面生成修边路径且先修边方向-右边、下边',
    { key1: 'engraving', key2: 'bottomRight' },
  ],
  [
    '雕刻机-切割参数-修边设置-双面板修边-修两边',
    { key1: 'engraving', key2: 'is_double_panel_four_trim-false' },
  ],
  [
    '雕刻机-切割参数-修边设置-双面板修边-修四边',
    { key1: 'engraving', key2: 'is_double_panel_four_trim-true' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面板修边-修两边',
    { key1: 'engraving', key2: 'is_single_panel_four_trim-false' },
  ],
  [
    '雕刻机-切割参数-修边设置-单面板修边-修四边',
    { key1: 'engraving', key2: 'is_single_panel_four_trim-true' },
  ],
  [
    '雕刻机-切割参数-修边设置-只修长边-true',
    { key1: 'engraving', key2: 'trimLSingle1' },
  ],
  [
    '雕刻机-切割参数-修边设置-只修短边-true',
    { key1: 'engraving', key2: 'double_panel_trim_short1' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边长度补偿',
    { key1: 'engraving', key2: 'trim_length_compensation' },
  ],
  [
    '雕刻机-切割参数-修边设置-修边值为0不生成路径',
    { key1: 'engraving', key2: 'trim_not_generate_path' },
  ],
  [
    '雕刻机-切割参数-锯切设置-启用锯切',
    { key1: 'engraving', key2: 'mentaojiSizeSetting' },
  ],
  [
    '雕刻机-切割参数-锯切设置-不生成生成切割路径',
    { key1: 'engraving', key2: 'noVerticalSaw' },
  ],
  [
    '雕刻机-切割参数-分层切割-铣槽拉槽分层切割',
    { key1: 'engraving', key2: 'layered_slot_cutting' },
  ],
  [
    '雕刻机-切割参数-小板分散排版',
    { key1: 'engraving', key2: 'scattered_layout' },
  ],
  [
    '雕刻机-排钻设置-启用排钻包-启用排钻包-true',
    { key1: 'engraving', key2: 'enabled' },
  ],
  [
    '雕刻机-排钻设置-排钻组合下刀-排钻组合下刀-true',
    { key1: 'engraving', key2: 'gang_drill_combination_enable' },
  ],
  [
    '雕刻机-排钻设置-加工设置-排钻加工模式-recent_hole',
    { key1: 'engraving', key2: 'recent_hole' },
  ],
  [
    '雕刻机-排钻设置-加工设置-排钻加工模式-group_hole',
    { key1: 'engraving', key2: 'drill_process_mode' },
  ],
  [
    '雕刻机-排钻设置-刀具列表-新增',
    { key1: 'engraving', key2: 'add_drill_knife' },
  ],
  [
    '雕刻机-排钻设置-刀具列表-删除',
    { key1: 'engraving', key2: 'del_drill_knife' },
  ],
  [
    '雕刻机-排钻设置-刀具列表-编辑',
    { key1: 'engraving', key2: 'edit_drill_knife' },
  ],
  ['雕刻机-排钻设置-排钻前缀', { key1: 'engraving', key2: 'prefix' }],
  ['雕刻机-排钻设置-排钻后缀', { key1: 'engraving', key2: 'suffix' }],
  ['雕刻机-排钻设置-排钻启动代码', { key1: 'engraving', key2: 'beginCode' }],
  ['雕刻机-排钻设置-排钻结束代码', { key1: 'engraving', key2: 'endCode' }],
  [
    '雕刻机-排钻设置-从孔列表-新增',
    { key1: 'engraving', key2: 'add_sec_hole' },
  ],
  [
    '雕刻机-排钻设置-从孔列表-删除',
    { key1: 'engraving', key2: 'del_sec_hole' },
  ],
  [
    '雕刻机-排钻设置-加工设置-组合下刀基准-main',
    { key1: 'engraving', key2: 'drill_benchmark_main' },
  ],
  [
    '雕刻机-排钻设置-加工设置-组合下刀基准-end',
    { key1: 'engraving', key2: 'drill_benchmark_end' },
  ],
  [
    '雕刻机-一体机设置-输出一体机加工文件-输出一体机加工文件-true',
    { key1: 'engraving', key2: 'enable_integration_device' },
  ],
  // TODO
  [
    '雕刻机-一体机设置-文件格式-文件格式-xinhongtian',
    { key1: 'engraving', key2: 'xinhongtian' },
  ],
  [
    '雕刻机-一体机设置-文件格式-文件格式-pinmai',
    { key1: 'engraving', key2: 'pinmai' },
  ],
  [
    '雕刻机-一体机设置-文件格式-文件格式-ruinuo',
    { key1: 'engraving', key2: 'ruinuo' },
  ],
  [
    '雕刻机-一体机设置-文件格式-文件格式-kaihong',
    { key1: 'engraving', key2: 'kaihong' },
  ],
  [
    '雕刻机-一体机设置-文件格式-文件格式-jidong',
    { key1: 'engraving', key2: 'jidong' },
  ],
  [
    '雕刻机-一拖二雕刻机-输出一拖二雕刻机加工文件-输出一拖二雕刻机加工文件',
    { key1: 'engraving', key2: 'enable_one_for_two_device' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位起始点-工位起始点-true',
    { key1: 'engraving', key2: 'enable_one_for_two_start_position' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位起始点-工位起始点-左上角',
    { key1: 'engraving', key2: 'left_top' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位起始点-工位起始点-右上角',
    { key1: 'engraving', key2: 'right_top' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位起始点-工位起始点-左下角',
    { key1: 'engraving', key2: 'left_bottom' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位起始点-工位起始点-右下角',
    { key1: 'engraving', key2: 'right_bottom' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面加工板正面生成修边路径且先修边-true',
    { key1: 'engraving', key2: 'one_for_two_single_panel_trim' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面加工板正面生成修边路径且先修边方向-左边、上边',
    { key1: 'engraving', key2: 'topLeft' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面加工板正面生成修边路径且先修边方向-左边、下边',
    { key1: 'engraving', key2: 'bottomLeft' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面加工板正面生成修边路径且先修边方向-右边、上边',
    { key1: 'engraving', key2: 'topRight' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面加工板正面生成修边路径且先修边方向-右边、下边',
    { key1: 'engraving', key2: 'bottomRight' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-双面板修边-修两边',
    { key1: 'engraving', key2: 'one_for_two_is_double_panel_four_trim_false' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-双面板修边-修四边',
    { key1: 'engraving', key2: 'one_for_two_is_double_panel_four_trim_true' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面板修边-修两边',
    { key1: 'engraving', key2: 'one_for_two_is_single_panel_four_trim_false' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-单面板修边-修四边',
    { key1: 'engraving', key2: 'one_for_two_is_single_panel_four_trim_true' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-只修长边-true',
    { key1: 'engraving', key2: 'one_for_two_trim_single' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-只修短边-true',
    { key1: 'engraving', key2: 'one_for_two_double_panel_trim_short' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-反面修边顺序-反面最开始修边',
    { key1: 'engraving', key2: 'one_for_two_trim_moment_first' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-反面修边顺序-反面孔槽加工后修边',
    { key1: 'engraving', key2: 'one_for_two_trim_moment_after' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-正面再修边',
    { key1: 'engraving', key2: 'one_for_two_second_trim_value' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-启用新版修边规则',
    { key1: 'engraving', key2: 'one_for_two_new_trim' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-修边长度补偿',
    { key1: 'engraving', key2: 'one_for_two_trim_length_compensation' },
  ],
  [
    '雕刻机-一拖二雕刻机-修边设置-修边值为0不生成路径',
    { key1: 'engraving', key2: 'one_for_two_trim_not_generate_path' },
  ],
  [
    '雕刻机-一拖二雕刻机-其他-自动上下料代码',
    { key1: 'engraving', key2: 'secondAutoSendStockCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-其他-暂停代码',
    { key1: 'engraving', key2: 'secondPauseCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位开始-工位1开始代码',
    { key1: 'engraving', key2: 'secondOddBeginCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位开始-工位2开始代码',
    { key1: 'engraving', key2: 'secondEvenBeginCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-正反面开始-正面开始代码',
    { key1: 'engraving', key2: 'secondBeginCodeF' },
  ],
  [
    '雕刻机-一拖二雕刻机-正反面开始-反面开始代码',
    { key1: 'engraving', key2: 'secondBeginCodeB' },
  ],
  [
    '雕刻机-一拖二雕刻机-正反面结束-正面结束代码',
    { key1: 'engraving', key2: 'secondEndCodeF' },
  ],
  [
    '雕刻机-一拖二雕刻机-正反面结束-反面结束代码',
    { key1: 'engraving', key2: 'secondEndCodeB' },
  ],
  [
    '雕刻机-一拖二雕刻机-板件翻面-工位1翻面代码',
    { key1: 'engraving', key2: 'secondRollCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-板件翻面-工位2翻面代码',
    { key1: 'engraving', key2: 'secondEvenRollCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位结束-工位1结束代码',
    { key1: 'engraving', key2: 'secondOddEndCode' },
  ],
  [
    '雕刻机-一拖二雕刻机-工位结束-工位2结束代码',
    { key1: 'engraving', key2: 'secondEvenEndCode' },
  ],
  // 锯切雕刻机
  [
    '雕刻机-锯切雕刻机-启用锯切雕刻机',
    { key1: 'engraving', key2: 'mentaoji_enable' },
  ],
  [
    '雕刻机-锯切雕刻机-刀库-新增',
    { key1: 'engraving', key2: 'add_knife_mentaoji' },
  ],
  [
    '雕刻机-锯切雕刻机-刀库-删除',
    { key1: 'engraving', key2: 'del_knife_mentaoji' },
  ],
  [
    '雕刻机-锯切雕刻机-刀库-编辑',
    { key1: 'engraving', key2: 'edit_knife_mentaoji' },
  ],
  ['雕刻机-锯切雕刻机-加工工艺', { key1: 'engraving', key2: 'processType' }],
  ['雕刻机-锯切雕刻机-锯片用途-修边', { key1: 'engraving', key2: 'sawToTrim' }],
  [
    '雕刻机-锯切雕刻机-锯片用途-切割下料',
    { key1: 'engraving', key2: 'sawToCut' },
  ],
  [
    '雕刻机-锯切雕刻机-不生成纵向锯片切割路径',
    { key1: 'engraving', key2: 'noVerticalSaw1' },
  ],
  [
    '雕刻机-锯切雕刻机-锯片使用条件-有可用路径便使用',
    { key1: 'engraving', key2: 'mentaojiSizeSetting_false' },
  ],
  [
    '雕刻机-锯切雕刻机-锯片使用条件-余料剩余尺寸小于多少时才使用',
    { key1: 'engraving', key2: 'mentaojiSizeSetting_true' },
  ],
  [
    '雕刻机-锯切雕刻机-切割方式-一刀拉穿大板',
    { key1: 'engraving', key2: 'sawThrough_false' },
  ],
  [
    '雕刻机-锯切雕刻机-切割方式-余料剩余尺寸小于多少时才直接一刀拉穿',
    { key1: 'engraving', key2: 'sawThrough_true' },
  ],
  [
    '雕刻机-锯切雕刻机-启用锯片厚度排版',
    { key1: 'engraving', key2: 'sawToLayout' },
  ],
  [
    '雕刻机-锯切雕刻机-已封好不再切的大板边-是否开启',
    { key1: 'engraving', key2: 'edgeNoSaw' },
  ],
  [
    '雕刻机-锯切雕刻机-开料直刀切割路径主体改用锯片',
    { key1: 'engraving', key2: 'sawReplaceEnable' },
  ],
  [
    '雕刻机-锯切雕刻机-生成先切断余料的横切路径',
    { key1: 'engraving', key2: 'firstCutSurplus' },
  ],
  [
    '雕刻机-锯切雕刻机-切断后的余料可入库和打印标签',
    { key1: 'engraving', key2: 'surplusStoreAndLabeling' },
  ],
  [
    '雕刻机-锯切雕刻机-余料最小可用尺寸-宽度',
    { key1: 'engraving', key2: 'surplusMinWidth' },
  ],
  [
    '雕刻机-锯切雕刻机-余料最小可用尺寸-长度',
    { key1: 'engraving', key2: 'surplusMinLength' },
  ],
  [
    '雕刻机-锯切雕刻机-余料满足最小可用尺寸才生成横切余料路径',
    { key1: 'engraving', key2: 'crossCutOnlyMinSurplusSize' },
  ],
  [
    '雕刻机-锯切雕刻机-反面截取余料',
    { key1: 'engraving', key2: 'backCutSurplus' },
  ],
  [
    '雕刻机-锯切雕刻机-焊接板才使用锯片加工',
    { key1: 'engraving', key2: 'sawCutOnlyWeld' },
  ],
  [
    '雕刻机-锯切雕刻机-最小余料匹配宽度差',
    { key1: 'engraving', key2: 'minSurplusWidthDiff' },
  ],
  [
    '雕刻机-锯切雕刻机-焊接板排版间隙',
    { key1: 'engraving', key2: 'sawBoardGap' },
  ],
  [
    '雕刻机-锯切雕刻机-按板件长度依次排版',
    { key1: 'engraving', key2: 'sortByHeight' },
  ],
  // 雕刻机-NC导出设置
  [
    '雕刻机-NC导出设置-开料机文件名设置-按双工位自动排序',
    { key1: 'engraving', key2: 'doubleStationSortName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-下料文件名生成加工序号',
    { key1: 'engraving', key2: 'is_generate_process_sort_number' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-大板序号位数补偿到',
    { key1: 'engraving', key2: 'stockNumLength' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-标签机开头',
    { key1: 'engraving', key2: 'labelMachineName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-加工中心开头',
    { key1: 'engraving', key2: 'machineCenterName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-正面',
    { key1: 'engraving', key2: 'front_info' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-反面',
    { key1: 'engraving', key2: 'back_info' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-分隔符',
    { key1: 'engraving', key2: 'hasDelimiter' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件名设置-高光面翻面放板',
    { key1: 'engraving', key2: 'custom_high_gloss_reverse' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-正反面合并',
    { key1: 'engraving', key2: 'doubleMerge' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-正反面合并-反面结束代码',
    { key1: 'engraving', key2: 'bEnd1' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-正反面合并-正面开始代码',
    { key1: 'engraving', key2: 'fBegin1' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-正反面合并-文件名显示正反面信息',
    { key1: 'engraving', key2: 'displayfbInfo' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-单工位合并',
    { key1: 'engraving', key2: 'singleStation' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-单工位合并-反面开始代码',
    { key1: 'engraving', key2: 'bBegin2' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-单工位合并-反面结束代码',
    { key1: 'engraving', key2: 'bEnd2' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-单工位合并-正面开始代码',
    { key1: 'engraving', key2: 'fBegin2' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-单工位合并-正面结束代码',
    { key1: 'engraving', key2: 'fEnd2' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-双工位合并',
    { key1: 'engraving', key2: 'doubleStation' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-双工位合并-反面开始代码',
    { key1: 'engraving', key2: 'bBegin3' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-双工位合并-反面结束代码',
    { key1: 'engraving', key2: 'bEnd3' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-双工位合并-正面开始代码',
    { key1: 'engraving', key2: 'fBegin3' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件合并-双工位合并-正面结束代码',
    { key1: 'engraving', key2: 'fEnd3' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中注释-开料文件开头加入当前大板件信息',
    { key1: 'engraving', key2: 'beforePlankAddInfo' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中注释-大板信息',
    { key1: 'engraving', key2: 'plankInfo' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中注释-开料文件开头加入工位代码',
    { key1: 'engraving', key2: 'beforePlank' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中注释-开料文件换刀前加入工位代码',
    { key1: 'engraving', key2: 'beforeStartKnife' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-Z坐标补充',
    { key1: 'engraving', key2: 'zAddtion' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-每行NC末尾加分号',
    { key1: 'engraving', key2: 'addSemicolon' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-文件名格式-默认文件名',
    { key1: 'engraving', key2: 'defaultName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-文件名格式-星辉设备专用文件名',
    { key1: 'engraving', key2: 'dedicatedName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-输出雕刻机文件格式',
    { key1: 'engraving', key2: 'fileExtensionName' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件中类型-反面不加工时仍然生成含有反面结束代码的反面NC文件',
    { key1: 'engraving', key2: 'stillGenerate' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件夹-根据大板颜色、厚度、材质归为不同文件夹(贴标文件一起)',
    { key1: 'engraving', key2: 'useCategoryFolder' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件夹-同尺寸大板下料文件放在同一个文件夹',
    { key1: 'engraving', key2: 'same_size_sheet_cutting_files' },
  ],
  [
    '雕刻机-NC导出设置-开料机文件夹-贴标图片跟随贴标文件放在NC文件夹里',
    { key1: 'engraving', key2: 'label_image_in_nc_folder' },
  ],
  [
    '雕刻机-NC导出设置-加工指令设置-加工G指令简写',
    { key1: 'engraving', key2: 'GCommandShorthand' },
  ],
  [
    '雕刻机-NC导出设置-加工指令设置-Z轴转W轴排钻刀具',
    { key1: 'engraving', key2: 'z_to_w_gang_drill' },
  ],
  [
    '雕刻机-NC导出设置-文件格式设置-换行符格式设置-window',
    { key1: 'engraving', key2: 'platform_window' },
  ],
  [
    '雕刻机-NC导出设置-文件格式设置-换行符格式设置-unix',
    { key1: 'engraving', key2: 'platform_unix' },
  ],
  [
    '雕刻机-NC导出设置-文件格式设置-文件编码格式设置-UTF-8',
    { key1: 'engraving', key2: 'fileEncoding_utf-8' },
  ],
  [
    '雕刻机-NC导出设置-文件格式设置-文件编码格式设置-带bom的UTF-8',
    { key1: 'engraving', key2: 'fileEncoding_bom' },
  ],
  [
    '雕刻机-NC导出设置-文件格式设置-文件编码格式设置-ansi',
    { key1: 'engraving', key2: 'fileEncoding_ansi' },
  ],
  [
    '雕刻机-NC导出设置-板件条码设置-板件条码唯一',
    { key1: 'engraving', key2: 'uniqueBarCode' },
  ],
  [
    '雕刻机-NC导出设置-板件条码设置-生成简易格式标签条码',
    { key1: 'engraving', key2: 'genSimpleLabelBarcode' },
  ],
  [
    '雕刻机-NC导出设置-代码位置设置-工位结束代码在反面结束代码前面生成',
    { key1: 'engraving', key2: 'stationEndCodeBeforeEndCodeB' },
  ],
  // [
  //   '雕刻机-NC导出设置-单独文件加工设置-输出单独文件加工斜边款海棠角和斜边拉手',
  //   { key1: 'engraving', key2: 'handleSlope' },
  // ],
  [
    '雕刻机-NC导出设置-单独文件加工设置-输出单独文件加工圆弧折弯部分的直槽-true',
    { key1: 'engraving', key2: 'straight_arc_slot_true' },
  ],
  [
    '雕刻机-NC导出设置-单独文件加工设置-启用单独文件加工设置-true',
    { key1: 'engraving', key2: 'enable_true' },
  ],
  [
    '雕刻机-NC导出设置-单独文件加工设置-二次加工文件合并-true',
    { key1: 'engraving', key2: 'mergeFile_true' },
  ],
  [
    '雕刻机-NC导出设置-板件条码设置-板件条码唯一(打包专用)-uniqueBarCodeForPack',
    { key1: 'engraving', key2: 'uniqueBarCodeForPack' },
  ],
  // 雕刻机贴标设置
  [
    '雕刻机-贴标设置-自动贴标顺序设置-按照开料顺序贴标',
    { key1: 'engraving', key2: 'cutOrder' },
  ],
  [
    '雕刻机-贴标设置-自动贴标顺序设置-按照排版结果从下往上贴标',
    { key1: 'engraving', key2: 'toTop' },
  ],
  [
    '雕刻机-贴标设置-自动贴标顺序设置-按照排版结果从上往下贴标',
    { key1: 'engraving', key2: 'toBottom' },
  ],
  [
    '雕刻机-贴标设置-贴标自动避让-贴标自动避让-true',
    { key1: 'engraving', key2: 'labelingDodge' },
  ],
  [
    '雕刻机-贴标设置-输出自动贴标文件',
    { key1: 'engraving', key2: 'labelingMachine' },
  ],
  [
    '雕刻机-贴标设置-贴标文件格式-贴标文件格式',
    { key1: 'engraving', key2: 'labelFormat' },
  ],
  [
    '雕刻机-贴标设置-贴标文件格式-自动上料代码在贴标代码前面生成',
    { key1: 'engraving', key2: 'label_after_send_stock' },
  ],
  [
    '雕刻机-贴标设置-翻面贴标设置-启用雕刻机翻面加工贴标模式',
    { key1: 'engraving', key2: 'labelOverturn' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-选择设定值',
    { key1: 'engraving', key2: 'rotateLabel' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-方向',
    { key1: 'engraving', key2: 'horizontal' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-≤值',
    { key1: 'engraving', key2: 'criticalValue' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-选择标签横边与小板固定边平行',
    { key1: 'engraving', key2: 'parallel_plank' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-标签横边',
    { key1: 'engraving', key2: 'parallel_approach' },
  ],
  [
    '雕刻机-贴标设置-标签旋转设置-生效对象',
    { key1: 'engraving', key2: 'effective_object' },
  ],
  [
    '雕刻机-贴标设置-台面设置-工位起始点-左上角',
    { key1: 'engraving', key2: 'labelingStartPosition_topLeft' },
  ],
  [
    '雕刻机-贴标设置-台面设置-工位起始点-右上角',
    { key1: 'engraving', key2: 'labelingStartPosition_topRight' },
  ],
  [
    '雕刻机-贴标设置-台面设置-工位起始点-左下角',
    { key1: 'engraving', key2: 'labelingStartPosition_bottomLeft' },
  ],
  [
    '雕刻机-贴标设置-台面设置-工位起始点-右下角',
    { key1: 'engraving', key2: 'labelingStartPosition_bottomRight' },
  ],
  [
    '雕刻机-贴标设置-台面设置-坐标基准对调-x轴对调',
    { key1: 'engraving', key2: 'xDatumSwap' },
  ],
  [
    '雕刻机-贴标设置-台面设置-坐标基准对调-y轴对调',
    { key1: 'engraving', key2: 'yDatumSwap' },
  ],
  [
    '雕刻机-贴标设置-贴标坐标偏移-X',
    { key1: 'engraving', key2: 'labelXOffset' },
  ],
  [
    '雕刻机-贴标设置-贴标坐标偏移-Y',
    { key1: 'engraving', key2: 'labelYOffset' },
  ],
  [
    '雕刻机-贴标设置-标签旋转后坐标偏移-标签旋转后坐标偏移按钮',
    { key1: 'engraving', key2: 'offsetAfterLabelRotation' },
  ],
  [
    '雕刻机-贴标设置-标签旋转后坐标偏移-X',
    { key1: 'engraving', key2: 'xOffsetAfterLabelRotation' },
  ],
  [
    '雕刻机-贴标设置-标签旋转后坐标偏移-Y',
    { key1: 'engraving', key2: 'yOffsetAfterLabelRotation' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标图片格式-jpg',
    { key1: 'engraving', key2: 'labelImageFormat_jpg' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标图片格式-bmp',
    { key1: 'engraving', key2: 'labelImageFormat_bmp' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标图片格式-png',
    { key1: 'engraving', key2: 'labelImageFormat_png' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-图片编码方式-png',
    { key1: 'engraving', key2: 'labelImageFormatNew_png' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-图片编码方式-jpeg',
    { key1: 'engraving', key2: 'labelImageFormatNew_jpeg' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-图片编码方式-bmp',
    { key1: 'engraving', key2: 'labelImageFormatNew_bmp' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-导出bmp真彩/黑白-真彩',
    { key1: 'engraving', key2: 'bmp_color_style_0' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-导出bmp真彩/黑白-黑白',
    { key1: 'engraving', key2: 'bmp_color_style_1' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标图片分辨率',
    { key1: 'engraving', key2: 'label_resolution' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-分隔符',
    { key1: 'engraving', key2: 'label_image_name_separator' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标序号起始数值',
    { key1: 'engraving', key2: 'front_labeling_start_num' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-标签图片根据大板分为不同文件夹',
    { key1: 'engraving', key2: 'label_img_big_plank_folder' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-贴标文件插入到对应大板的贴标图片文件夹中',
    { key1: 'engraving', key2: 'labeling_file_insert' },
  ],
  [
    '雕刻机-贴标设置-贴标图片设置-排版图序号自动补偿',
    { key1: 'engraving', key2: 'num_auto_offset' },
  ],
  [
    '雕刻机-NC导出设置-单独文件加工设置-输出单独文件加工斜边款海棠角和斜边拉手-true',
    { key1: 'engraving', key2: 'output_single_file_true' },
  ],
  [
    '雕刻机-切割参数-高光设置-仅带有反面孔槽的大板自动翻面-true',
    { key1: 'engraving', key2: 'auto_high_gloss_reverse' },
  ],
  [
    '雕刻机-切割参数-高光设置-高光板不转板-开启',
    { key1: 'engraving', key2: 'high_gloss_plank_no_rotate' },
  ],

  // [
  //   '雕刻机-NC导出设置-单独文件加工设置-输出单独文件加工斜边款海棠角和斜边拉手-false',
  //   { key1: 'engraving', key2: 'outputSingleFile_off' },
  // ],
  [
    '雕刻机-贴标设置-余料大板不生成贴标文件',
    { key1: 'engraving', key2: 'no_gen_labelling_file_to_surplus' },
  ],
  [
    '雕刻机-自动线对接-自动线对接设置-启用自动线对接-true',
    { key1: 'engraving', key2: 'auto_line_enable' },
  ],
  [
    '雕刻机-自动线对接-自动线对接设置-启用机械臂对接-true',
    { key1: 'engraving', key2: 'enable' },
  ],
  [
    '雕刻机-自动线对接-自动线对接设置-桦桦自动线-true',
    { key1: 'engraving', key2: 'huahua_auto_line' },
  ],
  // TODO
  [
    '原片管理-自动选用特殊大板',
    { key1: 'base_material', key2: 'is_auto_selected' },
  ],
  [
    '原片管理-自动添加特殊大板弹窗',
    { key1: 'base_material', key2: 'auto_add_special_plate' },
  ],
  [
    '原片管理-特殊大板只排超尺小板',
    { key1: 'base_material', key2: 'only_layout_too_big' },
  ],
  [
    '原片管理-原片下料刀选择',
    { key1: 'base_material', key2: 'plate_knife_map' },
  ],
  [
    '余料管理-单板件开始排版',
    { key1: 'surplus_storage', key2: 'single_choice_paiban' },
  ],
  [
    '余料管理-多板件开始排版',
    { key1: 'surplus_storage', key2: 'double_choice_paiban' },
  ],
  ['余料管理-不翻版加工', { key1: 'surplus_storage', key2: 'surplus_no_roll' }],
  ['补件仓库-删除', { key1: 'supplement', key2: 'delete' }],
  ['补件仓库-批量删除', { key1: 'supplement', key2: 'batch_delete' }],
  ['补件仓库-排版', { key1: 'supplement', key2: 'single_choice_paiban' }],
  ['补件仓库-批量排版', { key1: 'supplement', key2: 'double_choice_paiban' }],
  // TODO 五六
  [
    '五六面钻-设备类型-设备类型-fiveDock',
    { key1: 'dock56f', key2: 'dockType_five' },
  ],
  [
    '五六面钻-设备类型-设备类型-sixDock',
    { key1: 'dock56f', key2: 'dockType_six' },
  ],
  [
    '五六面钻-生成文件类型-生成文件类型',
    { key1: 'dock56f', key2: 'selectedDockFile' },
  ],
  ['五六面钻-通用参数设置-桦桦自动线', { key1: 'dock56f', key2: 'huahuaLine' }],
  ['五六面钻-通用参数设置-长边', { key1: 'dock56f', key2: 'huahua_longSide' }],
  ['五六面钻-通用参数设置-短边', { key1: 'dock56f', key2: 'huahua_shortSide' }],
  [
    '五六面钻-通用参数设置-坐标值保留位数',
    { key1: 'dock56f', key2: 'decimalNum' },
  ],
  [
    '五六面钻-特殊参数设置-XML2铣槽刀具编号',
    { key1: 'dock56f', key2: 'output5FDrillSlotKnifeCode' },
  ],
  [
    '五六面钻-特殊参数设置-XML2铣型刀具编号',
    { key1: 'dock56f', key2: 'output5FDrillShapeKnifeCode' },
  ],
  [
    '五六面钻-特殊参数设置-XML2板件纹理-横纹=',
    { key1: 'dock56f', key2: 'output5FDrillNormalTexdirCode' },
  ],
  [
    '五六面钻-特殊参数设置-XML2板件纹理-竖纹=',
    { key1: 'dock56f', key2: 'output5FDrillReverseTexdirCode' },
  ],
  [
    '五六面钻-特殊参数设置-XML2铣型刀具补偿',
    { key1: 'dock56f', key2: 'output5FDrillShapeKnifeOffset' },
  ],
  [
    '五六面钻-特殊参数设置-mpr侧面孔Z坐标基准面-板件上表面',
    { key1: 'dock56f', key2: 'dock56FDrillMprConHoleDir_false' },
  ],
  [
    '五六面钻-特殊参数设置-mpr侧面孔Z坐标基准面-板件下表面',
    { key1: 'dock56f', key2: 'dock56FDrillMprConHoleDir_true' },
  ],
  [
    '五六面钻-通用参数设置-通孔分双面打通',
    { key1: 'dock56f', key2: 'tow_side_con_hole' },
  ],
  [
    '五六面钻-通用参数设置-矩形板没有孔槽不输出文件',
    { key1: 'dock56f', key2: 'non_holes_not_files' },
  ],
  [
    '五六面钻-通用参数设置-正面文件标识',
    { key1: 'dock56f', key2: 'front_opposite_file_identifier' },
  ],
  [
    '五六面钻-通用参数设置-反面文件标识',
    { key1: 'dock56f', key2: 'front_opposite_file_identifier' },
  ],
  [
    '五六面钻-通用参数设置-圆弧描述方式-线段成型描述',
    { key1: 'dock56f', key2: 'line_points' },
  ],
  [
    '五六面钻-通用参数设置-圆弧描述方式-圆弧指令描述',
    { key1: 'dock56f', key2: 'arc_command' },
  ],
  [
    '五六面钻-通用参数设置-宽槽拆解为多条窄槽加工-true',
    { key1: 'dock56f', key2: 'split_slot' },
  ],
  [
    '五六面钻-通用参数设置-拆解后单条槽宽度',
    { key1: 'dock56f', key2: 'split_slot' },
  ],
  [
    '五六面钻-通用参数设置-相邻的等宽等深槽拉通处理',
    { key1: 'dock56f', key2: 'is_not_merge_slot' },
  ],
  [
    '五六面钻-通用参数设置-板件长边摆放方向选择框-true',
    { key1: 'dock56f', key2: 'drill_layout_dir' },
  ],
  [
    '五六面钻-通用参数设置-板件长边摆放方向-横向',
    { key1: 'dock56f', key2: 'drill_layout_dir_horizontal' },
  ],
  [
    '五六面钻-通用参数设置-板件长边摆放方向-纵向',
    { key1: 'dock56f', key2: 'drill_layout_dir_vertical' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向选择框-true',
    { key1: 'dock56f', key2: 'drill_solt_dir' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向-系统默认',
    { key1: 'dock56f', key2: 'drill_solt_dir_default' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向-前和左',
    { key1: 'dock56f', key2: 'drill_solt_dir_front_left' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向-前和右',
    { key1: 'dock56f', key2: 'drill_solt_dir_front_right' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向-后和左',
    { key1: 'dock56f', key2: 'drill_solt_dir_back_left' },
  ],
  [
    '五六面钻-通用参数设置-五/六面钻槽或异形放置方向-后和右',
    { key1: 'dock56f', key2: 'drill_solt_dir_back_right' },
  ],
  [
    '五六面钻-通用参数设置-前封边摆放方向-true',
    { key1: 'dock56f', key2: 'front_edge_fixed' },
  ],
  [
    '五六面钻-通用参数设置-固定在-前边',
    { key1: 'dock56f', key2: 'front_edge_fixed_front' },
  ],
  [
    '五六面钻-通用参数设置-固定在-后边',
    { key1: 'dock56f', key2: 'front_edge_fixed_back' },
  ],
  [
    '五六面钻-通用参数设置-固定在-左边',
    { key1: 'dock56f', key2: 'front_edge_fixed_left' },
  ],
  [
    '五六面钻-通用参数设置-固定在-右边',
    { key1: 'dock56f', key2: 'front_edge_fixed_right' },
  ],
  [
    '五六面钻-通用参数设置-坐标值保留位数',
    { key1: 'dock56f', key2: 'drill_decimal_num' },
  ],
  [
    '五六面钻-通用参数设置-板件长边≤',
    { key1: 'dock56f', key2: 'long_edge_rotate_range' },
  ],
  [
    '五六面钻-通用参数设置-夹手所在方向',
    { key1: 'dock56f', key2: 'drill_dir' },
  ],
  [
    '五六面钻-通用参数设置-夹手宽度(W)',
    { key1: 'dock56f', key2: 'drill_width' },
  ],
  [
    '五六面钻-通用参数设置-夹手长度(H)',
    { key1: 'dock56f', key2: 'drill_length' },
  ],
  [
    '五六面钻-通用参数设置-设备可加工的最大宽度',
    { key1: 'dock56f', key2: 'machine_max_width' },
  ],
  [
    '五六面钻-通用参数设置-板件摆放方式-自动避让夹手',
    { key1: 'dock56f', key2: 'plank_placement_auto' },
  ],
  [
    '五六面钻-通用参数设置-板件摆放方式-手动设置避让',
    { key1: 'dock56f', key2: 'plank_placement_handle' },
  ],
  [
    '五六面钻-通用参数设置-板件摆放方式-固定前封边',
    { key1: 'dock56f', key2: 'plank_placement_fixed' },
  ],
  [
    '五六面钻-通用参数设置-焊接板原边固定靠夹手-开启',
    { key1: 'dock56f', key2: 'welding_plate_placement_enable' },
  ],
  [
    '五六面钻-通用参数设置-焊接板夹手所在方向-前侧',
    { key1: 'dock56f', key2: 'welding_plate_placement_direction_front' },
  ],
  [
    '五六面钻-通用参数设置-焊接板夹手所在方向-后侧',
    { key1: 'dock56f', key2: 'welding_plate_placement_direction_back' },
  ],
  [
    '五六面钻-通用参数设置-焊接板夹手所在方向-左侧',
    { key1: 'dock56f', key2: 'welding_plate_placement_direction_left' },
  ],
  [
    '五六面钻-通用参数设置-焊接板夹手所在方向-右侧',
    { key1: 'dock56f', key2: 'welding_plate_placement_direction_right' },
  ],
  // PTP
  [
    'PTP-输出文件格式-输出文件格式-default',
    { key1: 'ptp', key2: 'ptpFileFormat_default' },
  ],
  [
    'PTP-输出文件格式-输出文件格式-mpr',
    { key1: 'ptp', key2: 'ptpFileFormat_mpr' },
  ],
  [
    'PTP-文件格式设置-换行符格式设置-windows',
    { key1: 'ptp', key2: 'platform_windows' },
  ],
  [
    'PTP-文件格式设置-换行符格式设置-unix',
    { key1: 'ptp', key2: 'platform_unix' },
  ],
  [
    'PTP-文件格式设置-文件编码格式设置-utf-8',
    { key1: 'ptp', key2: 'fileEncoding_utf-8' },
  ],
  [
    'PTP-文件格式设置-文件编码格式设置-utf8bom',
    { key1: 'ptp', key2: 'fileEncoding_utf8bom' },
  ],
  [
    'PTP-文件格式设置-文件编码格式设置-gbk',
    { key1: 'ptp', key2: 'fileEncoding_gbk' },
  ],
  ['PTP-文件格式设置-输出文件后缀', { key1: 'ptp', key2: 'fileSuffix' }],
  ['PTP-小板坐标-横向坐标', { key1: 'ptp', key2: 'xPointSymbol' }],
  ['PTP-小板坐标-纵向坐标', { key1: 'ptp', key2: 'yPointSymbol' }],
  ['PTP-小板坐标-升降坐标', { key1: 'ptp', key2: 'zPointSymbol' }],
  ['PTP-板件镜像-板件镜像设置-X轴镜像', { key1: 'ptp', key2: 'xDatumSwap' }],
  ['PTP-板件镜像-板件镜像设置-Y轴镜像', { key1: 'ptp', key2: 'yDatumSwap' }],
  ['PTP-xy轴互换-xy轴互换', { key1: 'ptp', key2: 'xyReverse' }],
  ['PTP-刀库-新增', { key1: 'ptp', key2: 'add_knife' }],
  ['PTP-刀库-编辑', { key1: 'ptp', key2: 'edit_knife' }],
  ['PTP-刀库-删除', { key1: 'ptp', key2: 'del_knife' }],
  ['PTP-程序-程序开始代码', { key1: 'ptp', key2: 'beginCode' }],
  ['PTP-程序-程序结束代码', { key1: 'ptp', key2: 'endCode' }],
  ['PTP-主轴刀-主轴刀换刀开始代码', { key1: 'ptp', key2: 'zzdKnifeBeginCode' }],
  ['PTP-主轴刀-主轴刀换刀结束代码', { key1: 'ptp', key2: 'zzdKnifeEndCode' }],
  ['PTP-垂直钻-垂直钻启动代码', { key1: 'ptp', key2: 'czzBeginCode' }],
  ['PTP-垂直钻-垂直钻结束代码', { key1: 'ptp', key2: 'czzEndCode' }],
  ['PTP-垂直钻-垂直钻换刀开始代码', { key1: 'ptp', key2: 'czzKnifeBeginCode' }],
  ['PTP-垂直钻-垂直钻换刀结束代码', { key1: 'ptp', key2: 'czzKnifeEndCode' }],
  ['PTP-侧钻-侧钻启动代码', { key1: 'ptp', key2: 'czBeginCode' }],
  ['PTP-侧钻-侧钻结束代码', { key1: 'ptp', key2: 'czEndCode' }],
  ['PTP-侧钻-侧钻换刀开始代码', { key1: 'ptp', key2: 'czKnifeBeginCode' }],
  ['PTP-侧钻-侧钻换刀结束代码', { key1: 'ptp', key2: 'czKnifeEndCode' }],
  ['PTP-暂停-暂停代码', { key1: 'ptp', key2: 'pauseCode' }],
  [
    'PTP-主轴刀和垂直钻Z轴安全高度-主轴刀和垂直钻Z轴安全高度',
    { key1: 'ptp', key2: 'main_axis_knife_bit_z' },
  ],
  [
    'PTP-侧钻Z轴安全高度-侧钻Z轴安全高度',
    { key1: 'ptp', key2: 'side_drill_bit_z' },
  ],
  [
    'PTP-侧钻X/Y轴安全距离-侧钻X/Y轴安全距离',
    { key1: 'ptp', key2: 'side_drill_bit_xy' },
  ],
  [
    'PTP-辅助功能-辅助功能-生成星辉设备专用信息',
    { key1: 'ptp', key2: 'xhDedicatedInfo' },
  ],
  ['PTP-辅助功能-主轴刀在最后加工', { key1: 'ptp', key2: 'zzdCutLast' }],
  [
    'PTP-输出设置-文件中生成小板尺寸注释',
    { key1: 'ptp', key2: 'size_annotate' },
  ],
  ['PTP-输出设置-每行NC末尾加分号', { key1: 'ptp', key2: 'semicolon' }],
  [
    '下载NC顺带导出标签文件',
    { key1: 'more_setting', key2: 'is_follow_export_tag' },
  ],
  ['顺带导出PDF', { key1: 'more_setting', key2: 'is_follow_export_tag_pdf' }],
  ['顺带导出图片', { key1: 'more_setting', key2: 'is_follow_export_tag_pic' }],
  [
    '更多设置-导出样表设置-板件条码唯一',
    { key1: 'more_setting', key2: 'uniqueBarCode' },
  ],
  [
    '更多设置-导出样表设置-生成简易格式板件条码',
    { key1: 'more_setting', key2: 'genSimpleLabelBarcode' },
  ],
  ['全局搜索-打开搜索', { key1: 'globalSearch', key2: 'openSearch' }],
  ['全局搜索-确认搜索', { key1: 'globalSearch', key2: 'confirmSearch' }],
])

export { buryPointPayloadMap }
